import React from 'react';
import { Table, Button, Popover, Input, Label, Progress } from 'reactstrap';
import Row from '../Row';
import { DisplayMoreRow } from '../DisplayMoreRow';
import $ from 'jquery';
import DropZoneTable from './DropZoneTable';
import { Flag } from 'flagger/react'
import { connect } from 'react-redux'
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class InfoTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageNumber: 1,
            prevPageLimit: 0,
            pageLimit: 10,
            rowsShown: 150,
            refPopoverOpen: false,
            statusPopoverOpen: false,
            importPopoverOpen: false,
            actionPopoverOpen: false,
            datePopoverOpen: false,
            loading: false,
            jumpToPopoverOpen: false,
            pageSizePopoverOpen: false,
            textPageNumber: 0,
            fromDate: '',
            toDate: '',
            display_all_assoc: false,
            sortConfig: { key: null, direction: 'asc' },
            ...props,
            filters: {
                reference: '',
                status: '',
                type: '',
                datetime: '',
                folder: ''
            },
            showFilters: false
        }

        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
        this.clearDates = this.clearDates.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    clearDates() {
        try {
            if (this.props.filters.fromdate) {
                this.props.clearFilter('fromdate');
            }
        }
        catch (error) {
            console.error(error)
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
    }

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };

    clearAllFilters = () => {
        this.setState({
            filters: {
                reference: '',
                status: '',
                type: '',
                datetime: '',
                folder: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.logs.length !== prevProps.logs.length) {
            let noPages = Math.ceil(this.props.logs.length / this.state.rowsShown);
            this.setState({
                numPages: noPages,
                currentPage: 0,
                loading: false,
                logs: this.props.logs
            })
        }
        if (this.state.currentPage !== prevState.currentPage || this.state.numPages !== prevState.numPages) {
            this.setState({
                textPageNumber: this.state.currentPage + 1
            })
        }

        if (this.state.textPageNumber !== prevState.textPageNumber) {
            this.setState({
                currentPage: this.state.textPageNumber - 1
            })
        }

        if (prevState.rowsShown !== this.state.rowsShown) {
            const noPages = Math.ceil(this.props.logs.length / this.state.rowsShown);
            this.setState({ numPages: noPages, currentPage: 0 });
        }

    }

    goToNextPage() {
        let page = this.state.currentPage + 1
        if (page < this.state.numPages)
            this.setState({
                currentPage: page
            })

        this.props.pageNumberChange(page)
    }

    goToPrevPage() {
        let page = this.state.currentPage - 1
        if (page >= 0)
            this.setState({
                currentPage: page
            })

        this.props.pageNumberChange(page)
    }

    toggle(id) {
        let popoverid = id + 'PopoverOpen';
        this.setState({
            [popoverid]: !this.state[popoverid]
        });
    }

    handleDateInputChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        this.setState({
            [name]: value
        })
    }

    goToPageNumber = (i) => {
        this.setState({
            currentPage: i,
            jumpToPopoverOpen: false
        })
    }

    adjustPageSize = (size) => {
        this.setState({
            rowsShown: parseInt(size),  // Ensure numeric value
            pageSizePopoverOpen: false
        }, () => {
            const noPages = Math.ceil(this.props.logs.length / this.state.rowsShown);
            this.setState({ numPages: noPages, currentPage: 0 });
        });
    };


    jumpToPageNumber = (value) => {
        let number = parseInt(value);
        if (number <= this.state.numPages && number > 0) {
            this.setState({
                textPageNumber: number,
                jumpToPopoverOpen: false
            })
        }
    }

    clearDates = () => {
        this.setState({
            todate: '',
            fromdate: ''
        })

        this.props.clearDates();
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = this.state.logs ?? this.props.logs ?? [];

            const sortedLogs = [...logs].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                if (key === 'Date') {
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                }

                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                logs: sortedLogs,
                sortConfig: { key, direction }                
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, onSort, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === filterKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
      >
        <div className="s-grid-title-cell-filter" onClick={() => this.onSort(onSort)}>
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };

    render() {

        var b = true
        let grid_css = '';
        let id
        let rows = []
        let pageignation = <div />
        let is_checked = false;
        let progress;

        const { localisation } = this.props.userReducer;

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let startItem = this.state.currentPage * this.state.rowsShown;

        let endItem = startItem + this.state.rowsShown;

        let logsToRender = (this.state.logs?.length ? this.state.logs : this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                (field ?? '').toString().toLowerCase().includes(value.toLowerCase());

            const extractDatePortion = (dateStr) => {
                if (!dateStr) return '';
                const date = new Date(dateStr);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = String(date.getFullYear()).slice(2); // Get last 2 digits of year

                return `${day}/${month}/${year}`; // e.g. "03/04/25"
            };


            const userInput = filters.datetime.trim();
            const matchDate = userInput
                ? extractDatePortion(file.datetime).includes(userInput)
                : true;

            const fileReference = file.metadata && file.metadata.DocumentID
                ? file.metadata.DocumentID
                : file.reference;
            const fileFolder = file.metadata ? file.metadata.Folder : '';

            return (
                matches(fileReference, filters.reference) &&
                matches(file.status, filters.status) &&
                matches(file.type, filters.type) &&
                matches(fileFolder, filters.folder) &&
                matchDate
            );
        });

        if (logsToRender) {

            logsToRender.forEach((row, i) => {
    
            if (i < startItem || i > endItem)
                return

            grid_css += b ? " s-grid-row" : " s-grid-row s-record-alt";
            b = !b

            if (this.props.checkedlogs && this.props.checkedlogs.includes(row))
                is_checked = true
            else
                is_checked = false

            let reference;

            if (row.metadata && row.metadata.DocumentID)
                reference = row.metadata.DocumentID;
            else
                reference = row.reference;

            id = "P" + row._id

            if (this.props.associated_events.length > 0) {
                var found = this.props.associated_events.find(element => {
                    return element.id == row._id || element.id == row.parentId;
                });

                rows.push(<Row
                    logsRow
                    expandLogs={this.props.expandLogs}
                    expandOpen={found ? (found.associated.length > 0 ? true : false) : false}
                    rightAlign={[5]}
                    viewPortfolio={false}
                    onRowClicked={this.props.onRowClicked}
                    is_checked={is_checked}
                    checked={this.props.checked}
                    i={i}
                    checkChange={this.props.checkChange}
                    refresh={this.props.refresh}
                    id={id}
                    fileid={row._id}
                    tr_css={grid_css}
                    filename={reference}
                    filetype={row.status}
                    filetypeIsStatus
                    documentref={row.metadata == null ? 'Automatic' : row.metadata.ImportType}
                    version={row.Type}
                    folder={row.metadata == null ? 'Not applicable' : row.metadata.Folder}                    
                    dated={row.datetime}
                    user={row.type}
                    file={row}
                    pages={1}
                    columnConfig={this.props.columnConfig}
                />);

                if (found && found.associated.length > 0) {
                    for (let j in found.associated) {
                        const assoc_row = found.associated[j];
                        if (!this.state.display_all_assoc && j > 20) {
                            rows.push(<DisplayMoreRow onClick={() => this.setState({ display_all_assoc: true })} tr_css={grid_css} displaying={20} total={found.associated.length} />);
                            break
                        }

                        if (this.props.checkedlogs && this.props.checkedlogs.includes(assoc_row))
                            is_checked = true
                        else
                            is_checked = false

                        let row_id = "P" + assoc_row._id;

                        if (assoc_row._id !== row._id)
                            rows.push(<Row
                                logsRow
                                editorpopoverchild
                                rightAlign={[5]}
                                viewPortfolio={false}
                                onRowClicked={this.props.onRowClicked}
                                is_checked={is_checked}
                                checked={this.props.checked}
                                checkChange={this.props.checkChange}
                                refresh={this.props.refresh}
                                i={j}
                                id={row_id}
                                fileid={assoc_row._id}
                                tr_css={grid_css}
                                filename={assoc_row.reference}
                                filetype={assoc_row.status}
                                filetypeIsStatus
                                documentref={assoc_row.metadata == null ? 'Automatic' : assoc_row.metadata.ImportType}
                                version={assoc_row.Type}
                                folder={assoc_row.metadata == null ? 'Not applicable' : assoc_row.metadata.Folder}
                                dated={assoc_row.datetime}
                                user={assoc_row.type}
                                file={assoc_row}
                                pages={1}
                                columnConfig={this.props.columnConfig}
                            />);
                    }
                }
            } else {
                rows.push(<Row
                    logsRow
                    expandLogs={this.props.expandLogs}
                    expandOpen={found ? (found.associated.length > 0 ? true : false) : false}
                    rightAlign={[5]}
                    viewPortfolio={false}
                    onRowClicked={this.props.onRowClicked}
                    is_checked={is_checked}
                    checked={this.props.checked}
                    i={i}
                    checkChange={this.props.checkChange}
                    refresh={this.props.refresh}
                    id={id}
                    fileid={row._id}
                    tr_css={grid_css}
                    filename={reference}
                    filetype={row.status}
                    filetypeIsStatus
                    documentref={row.metadata == null ? 'Automatic' : row.metadata.ImportType}
                    version={row.Type}
                    folder={row.metadata == null ? 'Not applicable' : row.metadata.Folder}
                    dated={row.datetime}
                    user={row.type}
                    file={row}
                    pages={1}
                    columnConfig={this.props.columnConfig}
                />);
            }
        });
        }

        if (this.props.logs) {
            let goToPageItems = [];
            let pageSizes = [10, 50, 100, 200, 500];
            let pageSizeItems = [];

            for (let i = 0; i < this.state.numPages; i++)
                goToPageItems.push(<li class="s-list-li s-list-default-li"><a onClick={() => this.goToPageNumber(i)} title={i} class="s-list-default-btn-default">{i + 1}</a></li>);

            for (const i of pageSizes)
                pageSizeItems.push(<li class="s-list-li s-list-default-li"><a onClick={() => this.adjustPageSize(i)} title={i} class="s-list-default-btn-default">{i}</a></li>);

            pageignation = <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : this.props.logs.length + ' Records' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : this.props.logs.length + ' Record'}</label>
                    <label class="s-pager-range">|</label>
                    <div class="s-pager-size">
                        <label class="s-pager-size-label">Page Size:</label>
                        <div class="s-pager-size-value s-inplace s-responsive-field-size-14"><div class="s-inplace-value-edit">
                            <input type="text" autocomplete="off" class="s-inplace-input" onChange={(e) => this.adjustPageSize(e.target.value)} value={this.state.rowsShown} id="5-106-input" />
                            <div onClick={() => this.setState({ pageSizePopoverOpen: !this.state.pageSizePopoverOpen })} title="Open selection list" id="pagesize-dropdown" style={{ cursor: 'pointer' }} class="s-inplace-edit-picker s-fonticon-btn s-btn-expand_m"></div>
                            <Popover placement="buttom" hideArrow={true} toggle={() => this.setState({ pageSizePopoverOpen: false })} isOpen={this.state.pageSizePopoverOpen} target={"pagesize-dropdown"} style={{ overflow: 'auto', maxHeight: '300px' }}>
                                <div class="s-scrollbar-slot s-list-default-scroll-slot">
                                    <div class="s-scrollbar-slot s-list-default-scroll-slot" style={{ paddingRight: '0px', minWidth: '50px' }}></div>
                                    <div class="s-scrollbar-view s-list-default-ul-row s-list-row">
                                        <ul class="s-list-ul s-list-default-ul s-list-col" style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>
                                            {pageSizeItems}
                                        </ul>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                        </div>
                        <label class="s-pager-size-label">Go to Page:</label>
                        <div class="s-pager-size-value s-inplace s-responsive-field-size-14"><div class="s-inplace-value-edit">
                            <input type="text" autocomplete="off" class="s-inplace-input" onChange={(e) => this.jumpToPageNumber(e.target.value)} value={this.state.textPageNumber} id="5-106-input" />
                            <div onClick={() => this.setState({ jumpToPopoverOpen: !this.state.jumpToPopoverOpen })} title="Open selection list" id="jump-dropdown" style={{ cursor: 'pointer' }} class="s-inplace-edit-picker s-fonticon-btn s-btn-expand_m"></div>
                            <Popover placement="buttom" hideArrow={true} toggle={() => this.setState({ jumpToPopoverOpen: false })} isOpen={this.state.jumpToPopoverOpen} target={"jump-dropdown"} style={{ overflow: 'auto', maxHeight: '300px' }}>
                                <div class="s-scrollbar-slot s-list-default-scroll-slot">
                                    <div class="s-scrollbar-slot s-list-default-scroll-slot" style={{ paddingRight: '0px', minWidth: '50px' }}></div>
                                    <div class="s-scrollbar-view s-list-default-ul-row s-list-row">
                                        <ul class="s-list-ul s-list-default-ul s-list-col" style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>
                                            {goToPageItems}
                                        </ul>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                        </div>
                    </div>
                    <label class="s-pager-size-label">Page {this.state.currentPage + 1} / {this.state.numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
                <div class="s-array-topbar-left">
                    <a onClick={this.props.selectAll} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <a onClick={this.props.exportRows} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link"></a>
                </div>
                
            </div>



        }

        if (this.props.loading)
            progress = <Progress color="info" animated value={100} />
        else
            progress = <div />


        return (
            <>
                {pageignation}
                < div class="s-slot-row" style={{ height: '600px' }}>
                    <div className='table-responsive-wrap'>
                        <Table responsive={true} hover={true} className="s-grid-table-head">
                            <thead>
                                <tr>
                                    {this.props.columnConfig?.expand && (
                                    <th className="s-grid-title-cell s-grid-title-cell-small">
                                        <div className="s-grid-title-empty"></div>
                                    </th>
                                    )}
                                    {this.props.columnConfig?.checkbox && (
                                    <th className="s-grid-title-cell s-grid-title-cell-small">
                                        <div className="s-grid-title-empty"></div>
                                    </th>
                                    )}
                                    {/* filterKey, onSort, labelKey, labelFallback */}
                                    {this.renderSortableFilterableHeader('reference', 'reference', "table_header_reference", "Reference")} 
                                    {this.renderSortableFilterableHeader('status', 'status', "table_header_status", "Status")}
                                    {this.renderSortableFilterableHeader('type', 'type', "table_header_action_type", "Action Type")} 
                                    {this.renderSortableFilterableHeader('datetime', 'datetime', "table_header_date", "Date")}
                                    {this.renderSortableFilterableHeader('folder', 'folder', "table_header_folder", "Folder")}

                                </tr>
                            </thead>
                        </Table>
                    </div>
                    <div class="s-grid-slot-body">
                        <DropZoneTable refresh={this.props.refresh} rows={rows} DocumentType={this.props.DocumentType} DocumentRef={this.props.DocumentRef} />
                        {progress}
                    </div>
                </div >
            </>
        );
    }
}

export default connect(state => state)(InfoTable);
